// src/pages/Accounts/incomeSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchIncomes,
  fetchIncomeCode,
  saveIncome,
  deleteIncome,
  fetchHeadAccs,
} from "./incomeThunk";
import { currentDateTime } from "../../lib/functions";

const initialState = {
  entryDate: currentDateTime(),
  list: [],
  incomeCode: "",
  headAccs:[],
  balances: {}, // supplier balances if needed  
  loading: false,
  error: null,
  selectedIncome: null,
  isEditIncome: false,
  refreshList: false,
};

const incomeSlice = createSlice({
  name: "incomes",
  initialState,
  reducers: {
    resetIncomes: () => initialState,
    setIncomeCode: (state, action) => {
    state.incomeCode = action.payload;
    },
    setEntryDate(state, action) {
      state.entryDate = action.payload;
    },
    setSelectedIncome(state, action) {
      state.selectedIncome = action.payload;
    },
    setIsEditIncome(state, action) {
      state.isEditIncome = action.payload;
    },
    setRefreshList(state, action) {
      state.refreshList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIncomes.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIncomes.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchIncomes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchIncomeCode.fulfilled, (state, action) => {
        state.incomeCode = action.payload;
      })      
      .addCase(fetchHeadAccs.fulfilled, (state, action) => {
        state.headAccs = action.payload;
      })
      .addCase(saveIncome.fulfilled, (state, action) => {
        state.refreshList = true;
      })
      .addCase(deleteIncome.fulfilled, (state, action) => {
        state.list = state.list.filter((e) => e.exp_id !== action.payload.id);
      });
  },
});

export const {
  resetIncomes,
  setIncomeCode,
  setEntryDate,
  setSelectedIncome,
  setIsEditIncome,
  setRefreshList,
} = incomeSlice.actions;

export default incomeSlice.reducer;
